export default __webpack_public_path__ + "static/media/product-award.7274a0cf.svg";